import React, { useState, useRef, useCallback, ChangeEvent } from 'react';
import * as Yup from 'yup';
import Drawer from '@material-ui/core/Drawer';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { AiOutlineGroup } from 'react-icons/ai';
import { FiCamera } from 'react-icons/fi';

import InputLogged from '../../../../../components/InputLogged';

import getValidationErrors from '../../../../../utils/getValidationErrors';
import othergroup_icon from '../../../../../assets/othergroup_icon.svg';
import api from '../../../../../services/api';
import { useAuth } from '../../../../../hooks/auth';
import { useRegisterAdded } from '../../../../../hooks/registerAdded';
import { useToast } from '../../../../../hooks/toast';
import no_image from '../../../../../assets/no_image.png';

import material_styles from '../drawer_styles/material_styles';
import tipos from '../../../utils/tiposGrupo';
import {
  AddNewGroup,
  DrawerTitle,
  DrawerInputWrapper,
  ImgInputWrapper,
  GrupoImgWrapper,
  DrawerContainer,
  CloseButton,
} from '../drawer_styles';
import { SubmitButtonWrapper, SubmitButton } from '../../styles';

interface CreateDefaultGroup {
  descricao: string;
  ordem: number;
}

interface GrupoSimplesProps {
  isMateriaPrima: boolean;
}

const GrupoSimples: React.FC<GrupoSimplesProps> = ({ isMateriaPrima }) => {
  const [prevImg, setPrevImg] = useState<File | string>('');
  const [isOpen, setIsOpen] = useState(false);

  const formRef = useRef<FormHandles>(null);
  const dataForm = new FormData();
  const { handleSetHasGroupUpdated } = useRegisterAdded();

  const classes = material_styles();

  const toggleDrawer = (open: boolean) => () => {
    setIsOpen(open);
  };

  const { user } = useAuth();
  const { addToast } = useToast();

  const handleGrupoImgChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        setPrevImg(e.target.files[0]);
      }
    },
    [],
  );

  const handleSubmit = useCallback(
    async (data: CreateDefaultGroup) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          descricao: Yup.string().required(
            'Informe o nome do grupo para continuar.',
          ),
        });

        await schema.validate(data, { abortEarly: false });

        dataForm.append('grupo_img', prevImg);
        dataForm.append('empresa_id', user.empresa_id.toString());
        dataForm.append('descricao', data.descricao);
        dataForm.append('ordem', '1');
        dataForm.append('ativo', 'true');

        isMateriaPrima
          ? dataForm.append('tipo', tipos.MATERIA_PRIMA)
          : dataForm.append('tipo', tipos.SIMPLES);

        api
          .post('/grupo', dataForm, {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(() => {
            setIsOpen(false);
            addToast({
              type: 'success',
              title: 'Grupo criado com sucesso',
            });

            handleSetHasGroupUpdated(true);
          });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);

          addToast({
            type: 'error',
            title: 'Preencha os dados corretamente pra continuar',
          });
        } else {
          const { message } = err.response.data;

          addToast({
            type: 'error',
            title: message,
          });
        }
      }
    },
    [
      addToast,
      user.empresa_id,
      dataForm,
      prevImg,
      isMateriaPrima,
      handleSetHasGroupUpdated,
    ],
  );

  return (
    <>
      <AddNewGroup onClick={toggleDrawer(true)}>
        <img src={othergroup_icon} alt="Grupo Simples" />
        <div>
          <p>Grupo Simples</p>
          <span>Alimetação, varejo em geral. materias primas e etc.</span>
        </div>
      </AddNewGroup>

      <Drawer anchor="right" open={isOpen} onClose={toggleDrawer(false)}>
        <CloseButton onClick={toggleDrawer(false)} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation">
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle>
                <h1>Grupo Padrão</h1>
                <span>Grupo para produtos simples, prontas para venda.</span>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <Form ref={formRef} onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12} className={classes.noPaddingBot}>
                    <GrupoImgWrapper>
                      <ImgInputWrapper>
                        <img
                          src={
                            prevImg ? URL.createObjectURL(prevImg) : no_image
                          }
                          alt="Grupo"
                        />

                        <label htmlFor="grupo_img">
                          <FiCamera size={20} />
                          <input
                            type="file"
                            id="grupo_img"
                            onChange={handleGrupoImgChange}
                          />
                        </label>
                      </ImgInputWrapper>
                    </GrupoImgWrapper>
                  </Grid>

                  <Grid item xs={12} className={classes.noPaddingTop}>
                    <DrawerInputWrapper>
                      <span>Nome:</span>

                      <InputLogged
                        name="descricao"
                        placeholder="Nome do Grupo"
                        icon={AiOutlineGroup}
                        autoFocus
                      />
                    </DrawerInputWrapper>
                  </Grid>

                  <Grid item xs={12} />

                  <Grid item xs={12}>
                    <SubmitButtonWrapper>
                      <SubmitButton type="submit">Salvar</SubmitButton>
                    </SubmitButtonWrapper>
                  </Grid>
                </Grid>
              </Form>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </>
  );
};

export default GrupoSimples;
